import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MODE_ADD, MODE_EDIT, MODE_UNKNOWN, DEFAULT_IP } from "app/utils/constant";
import { cmnAssignFromBase, cmnSetValByPath } from "app/utils/utils";
import axios from "axios";

export const PUSH_MOCK_ENABLED = false;

export const pushStatusMap = {
    0: "draft",
    1: "scheduled",
    2: "sent",
    3: "cancelled",
};

const mockPushInfo = {
    "push_id": "61e6d355-3be4-4e5d-b74e-5afa97c45053",
    "title_zh": "已排程通知 1",
    "title_en": "Scheduled Notification 1",
    "subtitle_zh": "這是一個已排程通知 1",
    "subtitle_en": "This is a scheduled notification 1",
    "message_zh": "這是通知 1 的詳細內容。此消息已排程在未來發送。",
    "message_en": "This is the detailed content for notification 1. This message is scheduled to be sent in the future.",
    "push_date": 1742972400.0,
    "push_medias": "https://unsplash.com/photos/ETRPjvb0KM0/download?force=true",
    "push_tags": [
        "adult",
        "caregiver"
    ],
    "action_url": "https://example.com/promotions/summer",
    "action_text": "Learn More",
    "time_option": 2,
    "push_target": 1
}

const initialPushInfo = {
    "push_id": "",
    "title_zh": "",
    "title_en": "",
    "subtitle_zh": "",
    "subtitle_en": "",
    "message_zh": "",
    "message_en": "",
    "push_date": new Date().getTime() / 1000,
    "push_medias": "",
    "push_tags": [],
    "action_url": "",
    "action_text": "",
    "action_url_en": "",
    "action_text_en": "",
    "time_option": 1,
    "push_target": 1,
    "push_status": undefined
};

const initialState = {
    pushEditMode: MODE_UNKNOWN,
    pushInfo: initialPushInfo,
    pushEditData: initialPushInfo
};

export const searchPushsByPage = (page, sendData, callback) => async (dispatch) => {
    if (PUSH_MOCK_ENABLED) {
        let action = createAction("mPushReq/tknAware/searchPushsByPage");
        let simulateResp = {
            "code": 1,
            "data": {
                "page": 1,
                "page_size": 30,
                "data": [...mockPushInfo]
            },
            "message": "成功",
            "message_en": "Success"
        };

        const thunkResult = await dispatch(action(simulateResp));
        commonHandleError(thunkResult.payload, callback);
    } else {
        const thunkResult = await dispatch(searchPushsByPageReq({ page: page, data: sendData }));

        commonHandleError(thunkResult.payload, callback);
    }
};

export const uploadPushImage = (file, callback) => async (dispatch) => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getuploadfileurl",
        {
            "usage": "push",
            "file": file.name
        });

    let data = postRes.data;

    if (1 == data?.code) {
        let putUrl = data.data.image_upload_url;
        let realImgUrl = data.data.image_url;
        let mimeType = file.type;
        let type = (mimeType.includes("image")) ? "image" : "video";
        let subName = file.name.substring(file.name.indexOf(".") + ".".length);

        let xhr = new XMLHttpRequest();
        xhr.open("PUT", putUrl, true);
        xhr.setRequestHeader("Content-Type", type + "/" + subName);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    callback(realImgUrl, "");
                } else {
                    callback(null, "upload failed:,", xhr.status, xhr.responseText);
                }
            }
        };

        xhr.send(file);
    } else {
        if (!data) {
            callback(null, "upload failed: no data");
        }
        else {
            callback(null, "upload failed, code:" + data.code + " message:" + data.message_en);
        }
    }
};

export const getPushDetail = (pushId, callback) => async (dispatch) => {
    let thunkResult;
    if (PUSH_MOCK_ENABLED) {
        let data = {};
        if (pushId) {
            data = mockPushInfo;
        }

        let action = createAction("mPushReq/tknAware/getPushDetail/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": data
        };

        thunkResult = await dispatch(action(simulateResp));
    } else {
        if (!pushId) {
            let action = createAction("mPushReq/tknAware/getPushDetail/fulfilled");
            let simulateResp = {
                "code": 1,
                "data": initialPushInfo
            };

            thunkResult = await dispatch(action(simulateResp));
        } else {
            let sendData = {
                "push_id": pushId
            };

            thunkResult = await dispatch(getPushDetailReq(sendData));
        }
    }


    commonHandleError(thunkResult.payload, callback);
};


export const getPushsByPage = (page, callback) => async (dispatch) => {
    if (PUSH_MOCK_ENABLED) {
        let action = createAction("mPushReq/tknAware/getPushsByPage/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": {
                "page": 1,
                "page_size": 30,
                "data": [
                    {
                        "push_id": "61e6d355-3be4-4e5d-b74e-5afa97c45053",
                        "title_zh": "已排程通知 1",
                        "title_en": "Scheduled Notification 1",
                        "subtitle_zh": "這是一個已排程通知 1",
                        "subtitle_en": "This is a scheduled notification 1",
                        "message_zh": "這是通知 1 的詳細內容。此消息已排程在未來發送。",
                        "message_en": "This is the detailed content for notification 1. This message is scheduled to be sent in the future.",
                        "push_date": 1742972400.0,
                        "push_medias": "https://unsplash.com/photos/ETRPjvb0KM0/download?force=true",
                        "push_tags": [
                            "adult",
                            "caregiver"
                        ],
                        "action_url": "https://example.com/promotions/summer",
                        "action_text": "Learn More",
                        "time_option": 2,
                        "push_target": 1
                    }
                ]
            },
            "message": "成功",
            "message_en": "Success"
        };

        const thunkResult = await dispatch(action(simulateResp));
        commonHandleError(thunkResult.payload, callback);
    } else {
        const thunkResult = await dispatch(getPushsByPageReq(page));
        commonHandleError(thunkResult.payload, callback);
    }
}

export const createPush = (sendData, callback) => async (dispatch) => {
    if (PUSH_MOCK_ENABLED) {
        let action = createAction("mPushReq/tknAware/createPush/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": {
                "push_id": "aabbcc"
            },
            "message": "成功",
            "message_en": "Success"
        };

        const thunkResult = await dispatch(action(simulateResp));
        commonHandleError(thunkResult.payload, callback);
    } else {
        const thunkResult = await dispatch(createPushReq(sendData));
        commonHandleError(thunkResult.payload, callback);
    }
};

export const updatePush = (sendData, callback) => async (dispatch) => {
    if (PUSH_MOCK_ENABLED) {
        let action = createAction("mPushReq/tknAware/updatePush/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": {},
            "message": "成功",
            "message_en": "Success"
        };

        const thunkResult = await dispatch(action(simulateResp));
        commonHandleError(thunkResult.payload, callback);
    } else {
        const thunkResult = await dispatch(updatePushReq(sendData));
        commonHandleError(thunkResult.payload, callback);
    }

};

export const deletePush = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(deletePushReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};


export const publishPush = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(publishPushReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const withdrawPush = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(withdrawPushReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

const getPushsByPageReq = createAsyncThunk("mPushReq/tknAware/getPushsByPage", async (page) => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getpushlist?page=" + page);
    return res.data;
});

const searchPushsByPageReq = createAsyncThunk("mPushReq/tknAware/searchPushsByPage", async (obj) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/searchpushtemplate?page=" + obj.page, obj.data);
    return res.data;
});

const createPushReq = createAsyncThunk("mPushReq/tknAware/createPush", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/createpushtemplate", data);
    return res.data;
});

const updatePushReq = createAsyncThunk("mPushReq/tknAware/updatePush", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatepushtemplate", data);
    return res.data;
});

const getPushDetailReq = createAsyncThunk("mPushReq/tknAware/getPushDetail", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getpushdetail", data);
    return res.data;
});

const deletePushReq = createAsyncThunk("mPushReq/tknAware/deletePush", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/deletepushtemplate", data);
    return res.data;
});

const publishPushReq = createAsyncThunk("mPushReq/tknAware/publishPush", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/publishpushtemplate", data);
    return res.data;
});

const withdrawPushReq = createAsyncThunk("mPushReq/tknAware/withdrawPush", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/withdrawpushtemplate", data);
    return res.data;
});
const commonHandleError = (data, callback) => {
    if (callback) {
        let baseErrorMsgObj = {
            message: "系統發生問題, 請稍後再試",
            message_en: "An unexpected error occurred. Please try again."
        }

        if (1 == data?.code) {
            callback(true, data);
        } else {
            callback(false, (data) ? (data) : (baseErrorMsgObj))
        }
    }
};

const rdxPushSlice = createSlice({
    initialState,
    name: "rdxPush",
    extraReducers: (builder) => {
        builder
            .addCase(getPushsByPageReq.fulfilled, (state, actions) => { })
            .addCase(searchPushsByPageReq.fulfilled, (state, actions) => { })
            .addCase(getPushDetailReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    let origPushData = data.data;

                    if (!data.data.push_id) {
                        state.pushInfo = origPushData;
                        state.pushEditData = origPushData;
                        state.pushEditMode = MODE_ADD;
                    } else {
                        state.pushInfo = cmnAssignFromBase(initialPushInfo, origPushData);
                        state.pushEditData = cmnAssignFromBase(initialPushInfo, origPushData);
                        state.pushEditMode = MODE_EDIT;
                    }
                }
            })
    },
    reducers: {
        setCreateLoading(state, actions) {
            let { loading } = actions.payload;
            if (loading) {
                state.pushEditMode = MODE_UNKNOWN;
            } else {
                state.pushEditMode = MODE_ADD;
            }
        },
        setEditPushData(state, actions) {

        },
        clearEditPush(state) {
            state.pushEditMode = MODE_UNKNOWN;
            state.pushInfo = initialPushInfo;
            state.pushEditData = initialPushInfo;
        },
        resetAllPushPageData(state) {
            state = initialState;
        },
        initPushSimpleData(state, actions) {
            let { data, projection, type } = actions.payload;

            if ("list" == type) {
                let resultData = (data) ? data : [];
                state[projection] = resultData;
            } else if ("obj" == type) {
                let base = {};
                switch (projection) {

                }

                let obj = cmnAssignFromBase(base, data);
                state[projection] = obj;
            }
        },
        setPushSimpleData(state, actions) {
            let { data, projection, path } = actions.payload;

            if (Array.isArray(data) && !path) {
                state[projection] = data;
            } else {
                let formatPath;
                if (path.indexOf(projection) == 0) {
                    let headStr = projection + ".";
                    formatPath = path.substring(headStr.length);
                } else {
                    formatPath = path;
                }
                cmnSetValByPath(state[projection], formatPath, data);
            }
        },
        setPushSimpleDataToPushData(state, actions) {
            let { data, projection, base } = actions.payload;

            if (Array.isArray(data)) {
                // console.log("list update:", projection, data);
                state.pushInfo[projection] = data;
            } else {
                let obj = Object.assign({}, base, data);
                if ("self" == projection) {
                    // console.log("self update:", projection, obj);
                    state.pushInfo = obj;
                } else {
                    // console.log("partial update:", projection, obj);
                    state.pushInfo[projection] = obj;
                }
            }
        }
    }
});

export const {
    setCreateLoading,
    setEditPushData, clearEditPush, resetAllPushPageData,
    initPushSimpleData, setPushSimpleData, setPushSimpleDataToPushData } = rdxPushSlice.actions;

export const rdxPushReducer = rdxPushSlice.reducer;